import { cn } from '@/lib/utils';
import type { LocationStatus } from '@/lib/types';

const STYLES: Record<LocationStatus, string> = {
  draft: 'bg-muted text-muted-foreground border-border',
  active: 'bg-primary/15 text-primary border-primary/30',
  suspended: 'bg-yellow-500/15 text-yellow-700 border-yellow-500/30',
  closed: 'bg-destructive/15 text-destructive border-destructive/30',
};

const LABELS: Record<LocationStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  suspended: 'Suspended',
  closed: 'Closed',
};

export function LocationStatusBadge({
  status,
  className,
}: {
  status: LocationStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        STYLES[status],
        className
      )}
    >
      {LABELS[status]}
    </span>
  );
}
